import { PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";
import { PDF_BODY_CLASS, PDF_SECTION_TITLE_CLASS } from "@/lib/proposalPdfTypography";
import type { SystemIncludedRow } from "@shared/dtoolsSystemSummary";

type Props = {
  rows: SystemIncludedRow[];
  grandTotalLabel?: string;
  grandTotalAmount?: string | null;
};

/** PDF Systems Included table — SYSTEM | DESCRIPTION | TOTAL (SGD). */
export default function DtoolsPdfSystemsIncludedTable({ rows, grandTotalLabel, grandTotalAmount }: Props) {
  if (rows.length === 0) return null;

  return (
    <section className="space-y-1.5" data-testid="dtools-pdf-systems-included-table" style={{ fontFamily: PROPOSAL_COPY_FONT }}>
      <h3 className={PDF_SECTION_TITLE_CLASS}>Systems Included</h3>
      <table className="dtools-pdf-compact-table w-full border-collapse text-left" style={{ fontFamily: PROPOSAL_COPY_FONT }}>
        <thead>
          <tr className="border-b border-[#1A2744]/20">
            <th className={`pb-1 pr-3 font-semibold text-[#1A2744] ${PDF_BODY_CLASS}`}>System</th>
            <th className={`pb-1 pr-3 font-semibold text-[#1A2744] ${PDF_BODY_CLASS}`}>Description</th>
            <th className={`pb-1 text-right font-semibold text-[#1A2744] ${PDF_BODY_CLASS}`}>Total (SGD)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key} className="border-b border-[#1A2744]/10" data-testid={`dtools-pdf-system-row-${row.key}`}>
              <td className={`py-1.5 pr-3 align-top font-medium text-[#1A2744] ${PDF_BODY_CLASS}`}>{row.system}</td>
              <td className={`py-1.5 pr-3 align-top text-[#4B5563] ${PDF_BODY_CLASS}`}>{row.description}</td>
              <td className={`py-1.5 text-right align-top font-semibold tabular-nums text-[#1A2744] ${PDF_BODY_CLASS}`}>
                {row.amount ?? "—"}
              </td>
            </tr>
          ))}
          {grandTotalAmount ? (
            <tr className="border-t border-[#1A2744]/20 bg-[#FAFAF7]" data-testid="dtools-pdf-systems-grand-total">
              <td colSpan={2} className={`py-1.5 pr-3 font-semibold text-[#1A2744] ${PDF_BODY_CLASS}`}>
                {grandTotalLabel ?? "Grand Total"}
              </td>
              <td className={`py-1.5 text-right font-semibold tabular-nums text-[#1A2744] ${PDF_BODY_CLASS}`}>
                {grandTotalAmount}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </section>
  );
}
